import { Component, Input, OnInit } from '@angular/core';
import { BreadcrumbsOptions } from "../../models/breadcrumbs-model";
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {RouterModule} from '@angular/router';


@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  standalone: true,
  styleUrls: ['./breadcrumbs.component.scss'],
  imports: [
    MatIconModule,
    MatButtonModule,
    CommonModule,
    TranslateModule,
    RouterModule
  ]
})
export class BreadcrumbsComponent implements OnInit {

  @Input() breadcrumbsData: BreadcrumbsOptions = {title: ''};

  constructor() {
  }

  ngOnInit(): void {
  }
}
